










import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { FramePuzzleModule, PuzzleBoxState, CollageUsageAndInfo, CollageInfo, PuzzleFormat, PuzzleBoxUpdateState } from '../../../../store/modules/framePuzzle';
import { AppModule } from '../../../../store/modules/app'
import { DesignApi, Configuration, AssetApi } from '@/rest'
import { Asset, CollageLayer, CollageLayers } from '@/rest/models'

@Component({
  name: "frame-edit",
  components: {
  }
})
export default class FrameEdit extends Vue {
  private hash: string = ""
  private timestamp: string = ""

  get isLandscapeFormat() {
    return FramePuzzleModule.isLandscapeFormat
  }

  get designNr() {
    return FramePuzzleModule.boxDesign
  }

  get parts() {
    return FramePuzzleModule.parts
  }

  get dru1AssetId() {
    return FramePuzzleModule.previewAssetId
  }

  get imageAssetId() {
    let usage = "frameimage"
    let info = FramePuzzleModule.allCollages[usage]
    if (info) {
      let onlyAssetId = info.assetId
      if (onlyAssetId !== undefined) {
        return onlyAssetId
      }
    }
    return ''
  }

  get puzzleBoxUpdateState() {
    return FramePuzzleModule.puzzleBoxUpdateState
  }

  get sessionId(): string {
    return AppModule.session.sessionId as string
  }

  @Watch('puzzleBoxUpdateState')
  updatePuzzleBox(puzzleBoxUpdateState: PuzzleBoxUpdateState) {
    if (puzzleBoxUpdateState === PuzzleBoxUpdateState.UPDATING_BOX_ASSET) {
      let self = this
      this.createDru1().then(() => {
        self.getHash()
      });
    }
  }

  get format() {
    if (FramePuzzleModule.format === PuzzleFormat.LANDSCAPE) {
      return 'landscape'
    }
    return 'portrait'
  }

  createTimestamp() {
    let date = new Date();
    this.timestamp = date.getUTCFullYear().toString()
      + ((date.getUTCMonth() + 1) > 9 ? '' : '0') + (date.getUTCMonth() + 1).toString()
      + (date.getUTCDate() > 9 ? '' : '0') + date.getUTCDate().toString()
      + (date.getUTCHours() > 9 ? '' : '0') + date.getUTCHours().toString()
      + (date.getUTCMinutes() > 9 ? '' : '0') + date.getUTCMinutes().toString()
      + (date.getUTCSeconds() > 9 ? '' : '0') + date.getUTCSeconds().toString()
  }

  get link() {
    let url = ''
    if (this.hash) {
      url = '/cpapi/assetThumbnail3dFrame/'
      url += this.sessionId
      url += '/' + this.dru1AssetId
      url += '/' + this.designNr
      url += '/' + this.parts
      url += '/' + this.format
      url += '/preview.png'
      url += '?timestamp=' + this.timestamp
      url += '&hash=' + this.hash
      url += '&title='
    }
    return url
  }

  getHash(): Promise<void> {
    this.createTimestamp()
    var self = this
    let path = '/cpapi/assetThumbnail3dFrame/' + this.dru1AssetId
    return new Promise<void>((resolve, reject) => {
      let designApi = new DesignApi(
        new Configuration({ basePath: '/rest' })
      )
      let generateHashRequest = { "value": path, "timestamp": self.timestamp };
      designApi.generateHash(generateHashRequest).then(
        (value) => {
          self.hash = value
          resolve()
        },
        (reason) => {
          window.console.log(reason)
          reject()
        });
    });
  }

  createDru1(): Promise<void> {
    var self = this
    return new Promise<void>((resolve, reject) => {
      let assetApi = new AssetApi(new Configuration({ basePath: '/rest' }))
      if (self.imageAssetId === '') {
        reject()
      }
      let assets: Asset[] = []
      Object.keys(FramePuzzleModule.allCollages).forEach(function (key, index) {
        let collageAsset = FramePuzzleModule.allCollages[key]
        var matches = key.match(/\d+$/);
        var pos = index;
        if (matches) {
          pos = Number(matches[0])
        }
        if (pos <= 1) {
          let asset: Asset = {};
          asset.id = collageAsset.assetId
          asset.rotation = collageAsset.rotation
          asset.ll = collageAsset.boundingBox.ll
          asset.ur = collageAsset.boundingBox.ur
          asset.pieces = FramePuzzleModule.parts
          if (asset.ur && asset.ur.length > 1 && asset.ll && asset.ll.length > 1) {
            let height = asset.ur[1] - asset.ll[1];
            let width = asset.ur[0] - asset.ll[0];
            asset.format = height > width ? "H" : "Q"
          }
          assets.splice(pos - 1, 0, asset)
        }
      });
      if (assets.length == 1) {
        let createDru1Request = { "customProductType": "FPU", "asset": assets[0], "sessionId": this.sessionId }
        assetApi.createDru1(createDru1Request).then(
          (value) => {
            FramePuzzleModule.SetPreviewAssetId(value)
            FramePuzzleModule.SetPuzzleBoxUpdateState(PuzzleBoxUpdateState.UPDATED)
            resolve()
          },
          (reason) => {
            window.console.log(reason)
            reject()
          });
      } else {
        reject()
      }
    });
  }

  createDefaultDru1(): Promise<void> {
    var self = this
    return new Promise<void>((resolve, reject) => {
      let assetApi = new AssetApi(new Configuration({ basePath: '/rest' }))
      if (self.imageAssetId !== '') {
        reject()
      }
      var createDefaultDru1Request = { "pieceCount": this.parts, "format": this.format, "sessionId": this.sessionId, "customProductType" : "FPU" }
      assetApi.createDefaultDru1(createDefaultDru1Request).then(
        (value) => {
          FramePuzzleModule.SetPreviewAssetId(value)
          FramePuzzleModule.SetPuzzleBoxUpdateState(PuzzleBoxUpdateState.UPDATED)
          resolve()
        },
        (reason) => {
          window.console.log(reason)
          reject()
        });
    });
  }

  mounted() {
    var self = this
    if (this.imageAssetId === '') {
      this.createDefaultDru1().then(() => {
        self.getHash()
      });
    } else {
      this.$nextTick(() => {
        if (this.puzzleBoxUpdateState === PuzzleBoxUpdateState.UPDATING_BOX_ASSET) {
          this.createDru1().then(() => {
            self.getHash()
          });
        } else if (this.puzzleBoxUpdateState === PuzzleBoxUpdateState.UPDATED) {
          self.getHash()
        }
      })
    }
  }
}
